import { compact } from 'lodash';

import {
  entityPlugin as Entity,
  errorPlugin as Error,
} from '@zapier/toolbox-redux-framework';

import Auth from 'app/auth';
import Min from 'app/min';
import Refresh from 'app/refresh';
import Rover from 'app/rover';
import Service from 'app/service';
import Track from 'app/track';
import safeExtend from 'app/common/utils/safeExtend';

const appPlugins = [
  Track,
  Auth,
  Service,
  Error,
  Min,
  Entity,
  Refresh,
  Rover,
];

export default function () {
  return {
    all: appPlugins,

    get routes() {
      // Grab all the route objects.
      const routeArgs = compact(appPlugins.map(plugin => plugin.routes));

      // Make sure they're all unique.
      const safeExtendRouteArgs = [{}].concat(routeArgs);

      return safeExtend(...safeExtendRouteArgs);
    },

    get reducers() {
      return appPlugins.map(plugin => plugin.reducers);
    },

    get actionsTypes() {
      return appPlugins.map(plugin => plugin.actionTypes);
    },
  };
}
